import { render, staticRenderFns } from "./TheResults2.vue?vue&type=template&id=ea38024c&scoped=true&"
import script from "./TheResults2.vue?vue&type=script&lang=js&"
export * from "./TheResults2.vue?vue&type=script&lang=js&"
import style0 from "./TheResults2.vue?vue&type=style&index=0&id=ea38024c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea38024c",
  null
  
)

export default component.exports